export function getAyudas(state) {
  return state.ayudas;
}
export function getPaginas(state) {
  return state.paginas;
}

